import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

type SearchState = {
  open: boolean
  keyword: string
}

const initialState: SearchState = {
  open: false,
  keyword: '',
}

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    openSearch: state => {
      state.open = true
    },
    closeSearch: state => {
      state.open = false
      state.keyword = ''
    },
    changeSearchKeyword: (state, action: PayloadAction<string>) => {
      state.keyword = action.payload
    },
  },
})

export const { openSearch, closeSearch, changeSearchKeyword } = searchSlice.actions

export default searchSlice.reducer
